import React, { useState } from 'react'

import styles from '../Signup.module.css'

import { TextField, EmailField, PasswordField } from 'components/Fields'

import Heading from 'components/Heading'
import Button from 'components/Button'

const ChooseSignup = ({ setActiveStep, handleSubmit, isSubmitting, formField }) => {
  const [showLogin, setShowLogin] = useState(false)
  const [errorMessage, setErrorMessage] = useState()

  const { email, password } = formField

  return (
    <div className={styles['step-wrapper']}>
      <Heading element="h3" nomargin bold center>
        Log Into Your Titans of CNC Network Account.
      </Heading>
      <div className={styles['signup-subtitle']}>
        Looks like you already have an Academy or Aerospace Academy account. Sign in below using those same credientials
      </div>
      <div className={styles['create-account-wrapper']}>
        <div className={styles['signup-fields']}>
          <div className={styles['signup-field-email']}>
            <EmailField
              name={email.name}
              label={email.label}
              className={styles['signup-input']}
              autoComplete="username"
              validations={email.validations}
            />
          </div>

          <div className={styles['signup-field-password']}>
            <PasswordField
              name={password.name}
              label={password.label}
              validations={password.validations}
              className={styles['signup-input']}
            />
          </div>
        </div>

        <div className={styles['form-footer']}>
          {errorMessage && <div className={styles['error']} dangerouslySetInnerHTML={{ __html: errorMessage }} />}
          <Button submit primary large centered disabled={isSubmitting} spinner={isSubmitting}>
            Login
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ChooseSignup
